import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import Modal from "react-modal"; // Install react-modal for modal functionality
import { FaMapMarkerAlt } from "react-icons/fa";

import FeedPost from "./feedpost/FeedPost";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
import profileData from "./feedpost/profiledata";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "../components/sidebar/leftsidebar"
import LeftResponsivesidebar from "../components/sidebar/left-responsive"
import Rightsidebar from "../components/sidebar/rightsidebar"
import RightResponsivesidebar from "../components/sidebar/right-responsive"
import Headmenu from "../components/sidebar/headmenu"
import { useNavigate } from "react-router-dom";
import Createpost from "../components/feedpost/createpost";
import profileimg from "../assets/profile.png";
import ReactPlayer from "react-player";
import groupimg from "../assets/groupimg.png";
import play from "../assets/play.png";
import viewIcon from "../assets/images/icons/viewIcon.png";
import likeIcon from "../assets/images/icons/likeIcon.png";
import shareIcon from "../assets/images/icons/shareIcon.png";
import commentIcon from "../assets/images/icons/commentIcon.png";
import smileyIcon from "../assets/images/icons/smileyIcon.png";
import Viewpost from "./feedpost/viewpost";

import crtpostimg from "../assets/images/crtpostimg.png";
import Microphone from "../assets/images/icons/microphone.png";
import Smiley from "../assets/images/icons/smiley.png";
import videoicon from "../assets/images/icons/video.png";
import galleryicon from "../assets/images/icons/gallery.png";
import goliveprf from "../assets/images/golive-prf.png";
import messagetext from "../assets/images/icons/message-text.png";
import morecircle from "../assets/images/icons/more-circle.png";
import leftconnect from "../assets/images/icons/leftconnect.png";
import Redheart from "../assets/images/icons/red-heart.png";
import RedlikeIcon from "../assets/images/icons/redlikeIcon.png";
import Whiteheart from "../assets/images/icons/white-heart.png";
import postData from "../components/feedpost/postdata";
import global from "../assets/images/icons/global.png";
import greenglobal from "../assets/images/icons/green-global.png";
import { groupData } from "../components/nestedtab/friendRequestsData";
import pipaanlogo from "../assets/pipaanlogo.png";
import closecircle from "../assets/images/icons/close-circle.png";
import { Swiper, SwiperSlide } from "swiper/react";
// import { uploadFiles } from "../../src/utils/uploadMedia"; // Adjust the path as needed
import userimg from "../assets/user.png";
import StoryBar from "../components/story/StoryBar";

export default function HomePage() {
  const [expandedPosts, setExpandedPosts] = useState(Array(profileData.length).fill(false)); // Ensure consistent hook call
  // ✅ Define state properly
  const [playingIndex, setPlayingIndex] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate(); // Navigation hook
  const [selectedFile, setSelectedFile] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false); // ✅ Handle loading state
  const [content, setContent] = useState(""); // ✅ Store post content
  const [mediaUrl, setMediaUrl] = useState(""); // ✅ Store media URL (if any)
  const [error, setError] = useState(null);
  // ✅ State to store the posts
  const [posts, setPosts] = useState([]);
  const [hasMore, setHasMore] = useState(true);  // ✅ Flag to track if there are more posts
  const [page, setPage] = useState(1);          // ✅ Track current page
  const loader = useRef(null);  // ✅ Ref to observe the scroll position
  const [expandedComments, setExpandedComments] = useState({}); // Track visibility of comment sections
  const [likedUsers, setLikedUsers] = useState([]); // State to store users who liked a post
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [selectedPostId, setSelectedPostId] = useState(null); // Track the post ID for the modal
  const [longPressTimeout, setLongPressTimeout] = useState(null); // Timeout for long press
  const [commentInputs, setCommentInputs] = useState({}); // State to store comment inputs for each post
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false); // Modal state for comments
  const [comments, setComments] = useState([]); // State to store comments
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [hasMoreUsers, setHasMoreUsers] = useState(true); // Whether more users are available
  const [followers, setFollowers] = useState([]);
  const [followings, setFollowings] = useState([]);

  const [profiles, setProfiles] = useState([
    { id: 1, name: "John Doe", avatar: "https://via.placeholder.com/50", link: "/profile/1" },
    { id: 2, name: "Jane Smith", avatar: "https://via.placeholder.com/50", link: "/profile/2" },
    { id: 3, name: "Tech Group", avatar: "https://via.placeholder.com/50", link: "/group/tech" }
  ]);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [followerFollowStatus, setFollowerFollowStatus] = useState({}); // Track follow status for followers
  const [followedUsers, setFollowedUsers] = useState({});  // ✅ Track clicked users
  const [followersTotal, setFollowersTotal] = useState(0);    // ✅ Total followers count
  const [followingsTotal, setFollowingsTotal] = useState(0);  // ✅ Total followings count
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded files
  const [filePreviews, setFilePreviews] = useState([]); // Store file previews

  // Function to handle post selection
  const handlePostSelection = (postId) => {
    setSelectedPostId(postId); // Set the selected post ID
  };

  // Find the selected post based on the selectedPostId
  // const selectedPost = posts.find((post) => post.id === selectedPostId);


  // Function to fetch user profile and navigate to myprofile page
  const handleUsernameClick = async (userId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) {
      alert("You must be logged in to view the profile.");
      return;
    }

    try {
      // Fetch user profile using the API
      const response = await axios.get(
        `https://pipaan.com360degree.com/api/user/profile?id=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        console.log("User profile fetched successfully:", response.data.result);

        // Redirect to the myprofile page with the user ID
        navigate(`/myprofile/${userId}`);
      } else {
        console.error("Failed to fetch user profile:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  // ✅ Fetch Followings
  const fetchFollowings = async () => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    const userID = sessionStorage.getItem("userID");

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/get-friends", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          filters: { allFollowings: true },
          page: 1,
          limit: 10,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      console.log("Followings Response:", data.result);   // ✅ Debugging log

      // ✅ Store user2id with corresponding friend_id in sessionStorage
      const user2IdMap = data.result.friends.reduce((acc, friend) => {
        acc[friend.id] = friend.User2.id;  // friend_id => user2id
        return acc;
      }, {});

      sessionStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
      // ✅ Ensure you're extracting the correct total count
      const totalFollowings = data.result.total || 0;
      setFollowingsTotal(totalFollowings);
      const formattedFollowings = data.result.friends.map((friend) => ({
        id: friend.id,
        friend_id: friend.id,
        first_name: friend.User2.first_name,
        user2id: friend.User2.id,

        username: friend.User2.username,
        profile_picture_url: friend.User2.profile_picture_url || userimg,
        mutualFriendsCount: friend.mutualFriendsCount || 0,
      }));
      console.log("formattedFollowings::", formattedFollowings)
      setFollowings(formattedFollowings);
    } catch (error) {
      console.error("Error fetching followings:", error);
    }
  };

  // ✅ Fetch Followers
  const fetchFollowers = async () => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    // const userID = sessionStorage.getItem("userID");

    const userID = sessionStorage.getItem("userID");
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/get-friends", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          filters: { allFollowers: true, },
          page: 1,
          limit: 10,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      // ✅ Store user2id with corresponding friend_id in sessionStorage
      const user1IdMap = data.result.friends.reduce((acc, friend) => {
        acc[friend.id] = friend.User1.id;  // friend_id => user2id
        return acc;
      }, {});

      sessionStorage.setItem("user1IdMap", JSON.stringify(user1IdMap));
      // ✅ Extract the `total` value for correct count
      setFollowersTotal(data.result.total);
      const formattedFollowers = data.result.friends.map((friend) => {
        const user1id = friend.User1.id;

        // ✅ Store user1id in sessionStorage
        sessionStorage.setItem(`user1id_${friend.friend_id}`, user1id);

        return {
          id: friend.id,
          friend_id: friend.id,
          user1id: user1id, // Store user1id
          first_name: friend.User1.first_name,
          username: friend.User1.username,
          profile_picture_url: friend.User1.profile_picture_url || userimg,
          mutualFriendsCount: friend.mutualFriendsCount || 0,
          user1FollowersCount: friend.user1FollowersCount || 0,
          myStatus: friend.myStatus,  // ✅ Store myStatus
          friendStatus: friend.friendStatus,  // ✅ Store friendStatus

        };
      });

      console.log("formattedFollowers :", formattedFollowers)

      setFollowers(formattedFollowers);
    } catch (error) {
      console.error("Error fetching followers:", error);
    }
  };


  const handleFollowerAction = async (friendId) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    // ✅ Get `user1id` from state instead of sessionStorage
    const user = followers.find((f) => f.id === friendId);
    if (!user || !user.user1id) {
      console.error("User1 ID not found.");
      return;
    }

    console.log("UserID being sent:", user.user1id); // ✅ Debugging log

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "pending",    // ✅ Use "unfollow" status
          user_id: user.user1id
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      // Update follow status in state
      setFollowerFollowStatus((prev) => ({
        ...prev,
        [friendId]: true, // Mark the user as followed
      }));

      // Refresh followers and followings lists
      fetchFollowers();
      fetchFollowings();

    } catch (error) {
      console.error("Error handling follower action:", error);
    }
  };
  useEffect(() => {
    if (searchQuery.length >= 3) {
      const filteredResults = profiles.filter(profile =>
        profile.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery, profiles]);

  // const token =   sessionStorage.setItem("accessToken", accessToken);
  console.log("Stored Token in homepage:", sessionStorage.getItem("accessToken"));
  useEffect(() => {
    console.log("Checking stored token:", localStorage.getItem("accessToken"));
  }, []);

  // Function to toggle comment section visibility
  const toggleCommentSection = (postId) => {
    setExpandedComments((prev) => ({
      ...prev,
      [postId]: !prev[postId], // Toggle visibility for the specific post
    }));
    // Open the comments modal
    fetchComments(postId); // Fetch comments for the post
  };
  // Function to fetch comments for a post
  const fetchComments = async (postId) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view comments.");
      return;
    }

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/comment/get-comments",
        {
          filters: { post_id: postId }, // Add post_id to filters
          page: 1,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        // Map the API response to match the UI structure
        const formattedComments = response.data.result.comments
          .filter((comment) => comment.is_deleted !== true) // ✅ REMOVE deleted comments
          .map((comment) => ({
            id: comment.id,
            name: `${comment.user.first_name} ${comment.user.last_name}`,
            avatar: comment.user.profile_picture_url || "/path-to-avatar.jpg",
            text: comment.content,
            time: new Date(comment.created_at).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
            likes: parseInt(comment.totalLikes, 10),
            replies: [],
            isLiked: comment.isLiked,
            post_id: comment.post_id,
            is_deleted: comment.is_deleted, // optional: track for debug
            media: comment.media_url || [], // ✅ Include media array

          }));

        console.log("Formatted Comments:", formattedComments); // Debugging log
        setComments(formattedComments); // Update the comments state
        setSelectedPostId(postId); // Track the post ID
        setIsCommentsModalOpen(true); // Open the modal
      } else {
        console.error("Failed to fetch comments:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };
  useEffect(() => {
    console.log("Updated Comments State:", comments);
  }, [comments]);
  useEffect(() => {
    const fetchData = async () => {
      await fetchFollowers(setFollowers); // Fetch followers and update state
      await fetchFollowings(setFollowings); // Fetch followings and update state
    };

    fetchData();
  }, []);

  const fetchReplies = async (commentId) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view replies.");
      return;
    }

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/comment/get-comments",
        {
          filters: { parent_id: commentId }, // Fetch replies for the specific comment
          page: 1,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        const replies = response.data.result.comments.map((reply) => ({
          id: reply.id,
          name: `${reply.user.first_name} ${reply.user.last_name}`,
          avatar: reply.user.profile_picture_url || "/path-to-avatar.jpg",
          text: reply.content,
          time: new Date(reply.created_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          likes: parseInt(reply.totalLikes, 10),
          isLiked: reply.isLiked,
          post_id: reply.post_id, // ✅ ADD THIS
        }));

        // Update the replies for the specific comment without duplicating
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === commentId
              ? {
                ...comment,
                replies: [
                  ...comment.replies.filter(
                    (existingReply) =>
                      !replies.some((newReply) => newReply.id === existingReply.id)
                  ), // Keep only unique replies
                  ...replies,
                ],
              }
              : comment
          )
        );
      } else {
        console.error("Failed to fetch replies:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching replies:", error);
    }
  };
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);

    const newMedia = files.map((file) => ({
      file: file, // Store the actual file
      type: file.type.startsWith("image/") ? "image" : "video",
      url: URL.createObjectURL(file), // Generate a preview URL
    }));

    setUploadedMedia((prev) => [...prev, ...newMedia]);
    console.log("New Media Added:", newMedia); // Debugging log
  };
  
  // Function to cancel long press
  const handleCommentLongPressEnd = () => {
    clearTimeout(longPressTimeout); // Clear the timeout if the press is released early
  };

  // Function to close the comments modal
  const closeCommentsModal = () => {
    setIsCommentsModalOpen(false);
    setComments([]);
  };
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    // ✅ Retrieve both tokens and user data
    const emailToken = sessionStorage.getItem("accessToken");
    const mobileToken = sessionStorage.getItem("accessTokenMobile");

    const emailUser = sessionStorage.getItem("user");
    const mobileUser = sessionStorage.getItem("usermobile");

    // ✅ Use mobile token if available, otherwise fallback to email token
    const activeToken = mobileToken || emailToken;
    const activeUser = mobileUser ? JSON.parse(mobileUser) : emailUser ? JSON.parse(emailUser) : null;

    if (activeToken) {
      setToken(activeToken);
    }

    if (activeUser) {
      setUser(activeUser);
    } else {
      navigate("/login");  // Redirect to login if no valid session
    }

    console.log("Active Token:", activeToken);
    console.log("Active User:", activeUser);

  }, [navigate]);



  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Retrieve user from login
    const storedUser = sessionStorage.getItem("user");
    // Retrieve userDoc from password reset
    const storedUserDoc = sessionStorage.getItem("userDoc");

    // ✅ If user exists from login, use it; otherwise, use userDoc from password reset
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    } else if (storedUserDoc) {
      setUserData(JSON.parse(storedUserDoc));
    }
  }, []);

  // ✅ Get User ID from sessionStorage
  const users = JSON.parse(sessionStorage.getItem("user"));
  const userId = users ? users.id : null;
  const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state
  const [activeTab, setActiveTab] = useState("Followers");


  // ✅ Function to fetch posts
  const fetchPosts = async () => {
    if (loading || !hasMore) return;  // Prevent multiple calls

    setLoading(true);
    setError(null);

    // ✅ Retrieve both tokens dynamically
    const emailToken = sessionStorage.getItem("accessToken");
    //  const mobileToken = sessionStorage.getItem("accessTokenMobile");

    // ✅ Use mobile token if available, otherwise fallback to email token
    const activeToken = emailToken;

    if (!activeToken) {
      console.error("❌ No authentication token found.");
      setError("Authentication token is missing. Please log in again.");
      setLoading(false);
      return;
    }
    const requestBody = {
      filters: { postType: "friend" },
      page: 1,
      limit: 100
    };

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/post/get-posts", {
        method: "POST",
        headers: {
          "token": `${activeToken}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const newPosts = data.result.posts;
        // 🔍 Log user_ids from all posts
        newPosts.forEach((post, index) => {
          console.log(`Post ${index + 1} → Post ID: ${post.id}, User ID: ${post.user_id}, Username: ${post.user?.username}`);
        });
        // ✅ Append new posts to the existing ones
        // setPosts((prevPosts) => [...prevPosts, ...newPosts]);

        ///showing single posts //
        setPosts(newPosts); // 👈 replace posts instead of appending

        // ✅ Check if there are more posts to load
        setHasMore(newPosts.length === 10);  // Continue if 10 posts are returned
        setPage((prevPage) => prevPage + 1);  // Increment the page
      } else {
        setError("Failed to fetch posts.");
      }
    } catch (error) {
      console.error("❌ Error fetching posts:", error);
      setError("An error occurred while fetching posts.");
    } finally {
      setLoading(false);
    }
  };

  const handleScrollLikedPost = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMoreUsers) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      fetchLikedUsers(selectedPostId, nextPage); // Fetch the next page of users
    }
  };
  // ✅ Scroll event handler
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 100 >=
      document.documentElement.scrollHeight
    ) {
      fetchPosts();  // Fetch more posts when scrolled near the bottom
    }
  };

  // ✅ Scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, hasMore]);

  // ✅ Infinite Scroll Observer
  const observer = useRef();

  const lastPostRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchPosts();  // Fetch more posts when scrolled to bottom
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  // ✅ Fetch posts on component mount
  useEffect(() => {
    fetchPosts();
  }, []);

  // Function to handle like action
  const handleLikeClick = async (postId) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token || !userId) {
      alert("You must be logged in to like a post.");
      return;
    }
    // Find the post to check if it's already liked
    const post = posts.find((p) => p.id === postId);
    const isLiked = post?.isLiked; // Add an `isLiked` property to track the like status

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/like/add-like",
        { post_id: postId, user_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        console.log("Post liked successfully:", response.data);
        // Update the like count and `isLiked` status in the UI
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.id === postId
              ? {
                ...post,
                likeCount: isLiked
                  ? Math.max((Number(post.likeCount) || 0) - 1, 0) // Decrease like count
                  : (Number(post.likeCount) || 0) + 1, // Increase like count
                isLiked: !isLiked, // Toggle the `isLiked` status
              }
              : post
          )
        );
      } else {
        console.error(
          isLiked
            ? "Failed to dislike post:"
            : "Failed to like post:",
          response.data.message
        );
      }
    } catch (error) {
      console.error(
        isLiked ? "Error disliking post:" : "Error liking post:",
        error
      );
    }
  };

  const handleCommentLikeClick = async (commentId) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token || !userId) {
      alert("You must be logged in to like a comment.");
      return;
    }

    // const comment = comments.find((c) => c.id === commentId);
    const comment =
      comments.find((c) => c.id === commentId) ||
      comments.flatMap((c) => c.replies || []).find((r) => r.id === commentId);
    const isLiked = comment?.isLiked;
    const postId = comment?.post_id;  // ✅ use post_id from the comment object

    if (!postId) {
      console.error("❌ Missing post_id in comment object");
      return;
    }

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/like/add-like",
        {
          post_id: Number(postId),
          comment_id: Number(commentId),
          user_id: Number(userId),
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setComments((prevComments) =>
          prevComments.map((c) => ({
            ...c,
            replies: c.replies?.map((r) =>
              r.id === commentId
                ? {
                  ...r,
                  likes: isLiked
                    ? Math.max((Number(r.likes) || 0) - 1, 0)
                    : (Number(r.likes) || 0) + 1,
                  isLiked: !isLiked,
                }
                : r
            ),
            ...(c.id === commentId
              ? {
                likes: isLiked
                  ? Math.max((Number(c.likes) || 0) - 1, 0)
                  : (Number(c.likes) || 0) + 1,
                isLiked: !isLiked,
              }
              : {}),
          }))
        );
      } else {
        console.error("Failed to like comment:", response.data.message);
      }
    } catch (error) {
      console.error("Error liking comment:", error);
    }
  };

  // Function to fetch users who liked a post
  const fetchLikedUsers = async (postId, page = 1) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view likes.");
      return;
    }
    // Reset state if fetching for a new post
    if (postId !== selectedPostId) {
      setLikedUsers([]); // Clear previous users
      setCurrentPage(1); // Reset pagination
      setHasMoreUsers(true); // Reset the "has more users" flag
      setSelectedPostId(postId); // Update the selected post ID

    }

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/like/get-likes",
        {
          filters: { post_id: postId }, // Add post_id to filters
          page: page,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        console.log("Fetched liked users response:", response.data);
        console.log("Fetched liked users responses:", response.data.result.likes);


        // Extract the `user` objects from the `likes` array
        // Extract the `user` objects from the `likes` array
        const users = response.data.result.likes.map((like) => ({
          ...like.user,
        }));
        setLikedUsers((prevUsers) => [...prevUsers, ...users]); // Append new users to the existing list
        setHasMoreUsers(users.length === 10); // Check if there are more users to load

        // setLikedUsers(users); // Set the extracted users in the state
        // setSelectedPostId(postId);
        setIsModalOpen(true); // Open the modal

      }

      // setSelectedPostId(postId);
      // setIsModalOpen(true);
      else {
        console.error("Failed to fetch liked users:", response.data.message);
        alert("No users found for this post.");

      }
    } catch (error) {
      console.error("Error fetching liked users:", error);
      alert("An error occurred while fetching liked users.");

    }
  };


  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setLikedUsers([]);
  };

  const toggleReadMore = (index) => {
    setExpandedPosts((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index]; // Toggle specific post
      return updated;
    });
  };

  const handleFollowClick = async (userId, privacyStatus) => {
    const token = sessionStorage.getItem("accessToken");

    if (!token) {
      console.error("No token found. Please log in.");
      return;
    }

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/friend/add-friend",
        {
          status: "pending",
          user_id: userId
        },
        {
          headers: {
            "token": `${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        console.log("✅ Friend request sent successfully:", response.data);

        // ✅ Update UI dynamically
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.user_id === userId
              ? {
                ...post,
                myStatus: privacyStatus === "public" ? "accepted" : "pending" // ✅ Public -> "Following", Private -> "Requested"
              }
              : post
          )
        );
      } else {
        console.error("❌ Failed to send friend request:", response.data.message);
      }
    } catch (error) {
      console.error("❌ Error sending friend request:", error);
    }
  };


  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  const userviewpost = { id: 1 };
  const [activeIndex, setActiveIndex] = useState(0); // Track active slide
  const [zoomLevels, setZoomLevels] = useState({}); // Store zoom levels for each image

  const imagespost = [
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    // demovideo
  ];
  // const isPlaying = playingIndex === `${index}-${imgIndex}`;
  // Check if the active slide is a video
  const isVideo = imagespost[activeIndex]?.type === "video";
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [images, setImages] = useState([]);
  // const [selectedPost, setSelectedPost] = useState(null);
  // Filter group data based on user.id
  const selectedGroup = groupData.find((group) => group.id === user?.id);

  const openPopup = (post) => {
    // setSelectedPost(post);
    setSelectedPostId(post.id); // Store ID separately if needed
    setIsPopupOpen(true);
    fetchComments(post.id); // 🔥 Fetch comments for the selected post
  };

  const selectedPost = posts.find((p) => p.id === selectedPostId); // lookup

  const closePopup = () => {
    setIsPopupOpen(false);
  };


  // Handle sending message
  const handleSendMessage = () => {
    if (message.trim() || images.length > 0) {
      const currentTime = new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });

      setMessages([...messages, { text: message, images, time: currentTime }]);
      setMessage('');
      setImages([]);
    }
  };
  // Handle image upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const uploadedImages = files.map((file) => URL.createObjectURL(file));
    setImages([...images, ...uploadedImages]);
  };
  // Zoom In Function (only for active image)
  const zoomIn = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: Math.min((prev[activeIndex] || 1) + 0.2, 2), // Max zoom 2x
    }));
  };

  // Zoom Out Function (reset zoom)
  const zoomOut = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: 1, // Reset to normal size
    }));
  };

  // Function to handle comment input change
  const handleCommentChange = (postId, value) => {
    setCommentInputs((prev) => ({
      ...prev,
      [postId]: value, // Update the comment input for the specific post
    }));
  };

  const uploadFiles = async () => {
    if (!uploadedMedia || uploadedMedia.length === 0) {
      alert("Please select files");
      return [];
    }

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type
    }));

    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        'https://pipaan.com360degree.com/api/aws/generate-presigned-url',
        { files: fileData },
        {
          headers: {
            'token': sessionStorage.getItem("accessToken")
          }
        }
      );

      if (!response.data.success) {
        throw new Error('Failed to generate pre-signed URLs');
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload media files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              'Content-Type': uploadedMedia[index].file.type,
              'Content-Encoding': 'binary'
            }
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );

      return preSignedUrls.map(item => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl // Extract fileUrl from API response
      }));

    } catch (error) {
      console.error('Upload error:', error);
      setError('Failed to upload files. Please try again.');
      throw new Error('Failed to upload files');
    }
  };

  // Clean up preview URLs when component unmounts
  useEffect(() => {
    return () => {
      uploadedMedia.forEach(media => {
        URL.revokeObjectURL(media.url);
      });
    };
  }, [uploadedMedia]);

  const handleCommentSubmit = async (postId, content, uploadedMedia) => {
    const token = sessionStorage.getItem("accessToken");
    const user = JSON.parse(sessionStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }

    try {
      let mediaPayload = [];
      if (uploadedMedia && uploadedMedia.length > 0) {
        // Upload files and get the media payload
        mediaPayload = await uploadFiles(uploadedMedia);
      }
      console.log("Media Payload:", mediaPayload); // Debugging log

      const response = await axios.post(
        "https://pipaan.com360degree.com/api/comment/add-comment",
        {
          media_url: mediaPayload,
          post_id: postId,
          content: content,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        const newComment = {
          id: response.data.result.id, // Use the returned ID
          name: `${user.first_name} ${user.last_name}`, // Use first_name and last_name from sessionStorage
          avatar: user.profile_picture_url || "/path-to-avatar.jpg", // Use user's profile picture or default avatar
          text: content,
          time: new Date(response.data.result.created_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          likes: 0,
          replies: [],
        };

        setComments((prevComments) => [...prevComments, newComment]); // Add the new comment to the state

        alert("Comment added successfully!");
        window.location.reload(); // Reload the page to see the new comment
        setUploadedFiles([]); // Clear uploaded files
        setFilePreviews([]); // Clear file previews

        // Optionally, refresh comments or update the UI
      } else {
        console.error("Failed to add comment:", response.data.message);
      }
      // window.location.reload(); // Reload the page to see the new comment
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  }
  const handleRemoveFile = (index) => {
    setUploadedMedia((prev) => prev.filter((_, i) => i !== index)); // Remove file
  };

  return (

    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />


      <main className="flex-1 p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        {/* Main Content */}
        <main className="flex ">

          {/* Feeds */}
          <div className="flex-1 lg:pr-5 space-y-6">

            {/* ✅ Display the Createpost component and pass posts */}
            <StoryBar />

            <Createpost posts={posts} fetchPosts={fetchPosts} />
            <div className="feed-tabs w-full mx-auto text-center lg:text-left">
              <div className="flex items-center gap-x-6 justify-between">
                <h2 className="text-3xl font-semibold tracking-tight text-balance text-black sm:text-4xl">
                  Feeds
                </h2>
                <div className="filter bg-[#EBF8ED] lg:p-3 flex space-x-4">
                  {["Groups", "Followers"].map((tab) => (
                    <button
                      key={tab}
                      className={`lg:p-3 ${activeTab === tab ? "active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" : "text-black"
                        } focus:outline-none`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>

              {/* Tab Content */}
              <div className="mt-4 ">

                {/* {
                  activeTab === "Interests" && (
                    <div>
                      {loading && <p>Loading posts...</p>}
                      <div className="w-full">
                        {posts.length > 0 ? (
                          posts.map((post, index) => (
                            <div key={index} className="p-4 border-b border-gray-300">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center" >
                                  <img
                                    src={post.user?.profile_picture_url || profileimg}
                                    alt={post.user?.username || "User"}
                                    className="w-12 h-12 rounded-full mr-4"

                                  />

                                  <div>
                                    <p className="font-bold cursor-pointer text-black-500" onClick={() => handleUsernameClick(post.user?.id)} // Call handleUsernameClick on click
                                    >{post.user?.username || "Unknown User"}</p>
                                    <p className="text-sm text-gray-500">{post.user?.email || "No Email"}</p>
                                  </div>
                                  {post.location && (
                                    <div className="mt-2 text-sm text-gray-500">
                                      <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                      {post.location}
                                    </div>
                                  )}
                                </div>

                                {!post.isOwn && (
                                  <button
                                    onClick={() => handleFollowClick(post.user_id, post.user?.privacy_status)}
                                    className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full mr-4 ${post.myStatus === "accepted"
                                      ? "bg-gray-400 text-white" // :white_check_mark: Following
                                      : post.myStatus === "pending"
                                        ? "bg-yellow-500 text-black" // :white_check_mark: Requested
                                        : "bg-[#095228] text-white" // :white_check_mark: Follow (default)
                                      }`}
                                    disabled={post.myStatus === "pending" || post.myStatus === "accepted"} // :white_check_mark: Disable after clicking
                                  >
                                    {post.myStatus === "accepted"
                                      ? "Following"
                                      : post.myStatus === "pending"
                                        ? "Requested"
                                        : "Follow"}
                                  </button>
                                )}
                              </div>
                              <button
                                placeholder="Share something..."
                                className=""
                                onClick={openPopup} >
                                <p className="mt-2 text-left">{post.content}</p>

                                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                  {post?.media_url?.length > 0 && (
                                    post?.media_url?.map((media, mediaIndex) => (
                                      <div key={mediaIndex}>
                                        {media?.media_type === "video" ? (
                                          <video
                                            src={media?.url}
                                            controls
                                            width="100%"
                                            className="rounded-lg shadow-md"
                                          />
                                        ) : (
                                          <img
                                            src={media?.url}
                                            alt={`media-${mediaIndex}`}
                                            width="100%"
                                            className="rounded-lg shadow-md"
                                          />
                                        )}
                                      </div>
                                    ))
                                  )}
                                </div>
                              </button>
                              <div className="react-social-cta flex justify-between items-center mt-8">
                                <div className="flex space-x-4">
                                  <button className="like flex items-center space-x-1 bg-[#BE1F2E] text-white px-3 py-1">
                                    <img
                                      src={post.isLiked ? Redheart : likeIcon} // Use a filled heart icon if liked
                                      alt="Like"
                                      className="mr-1 cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        handleLikeClick(post.id); // Call handleLikeClick
                                      }}
                                    />

                                    <span
                                      className="cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        fetchLikedUsers(post.id); // Call fetchLikedUsers
                                      }}
                                    >
                                      {post.likeCount}
                                    </span>
                                  </button>

                                  <button
                                    onClick={() => toggleCommentSection(post.id)} // Toggle comment section

                                    className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1">
                                    <img src={commentIcon} alt="Comment" className="mr-1" /> {post.commentCount}
                                  </button>

                                  <button className="eye flex items-center space-x-1 text-black">
                                    <img src={viewIcon} alt="Views" className="mr-1" /> {post.viewsCount} Views
                                  </button>
                                </div>
                                <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                  <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                                </button>
                              </div>
                              {isModalOpen && (
                                <div className="fixed inset-0 bg-[#00000005] w-full  z-40 flex justify-center items-center">
                                  <div
                                    onScroll={handleScrollLikedPost} // Attach the scroll handler

                                    className="bg-white p-6 rounded-lg  max-w-md w-full z-50 relative">
                                    <h2 className="text-xl font-bold mb-4">Users who liked this post</h2>
                                    <ul>
                                      {likedUsers.length > 0 ? (
                                        likedUsers.map((user, index) => (
                                          <li key={index} className="mb-2 flex items-center justify-between">
                                            <div className="flex items-center">
                                              <img
                                                src={user.profile_picture_url || profileimg}
                                                alt={user.username}
                                                className="w-8 h-8 rounded-full inline-block mr-2"
                                              />
                                              <div>
                                                <p className="font-bold">{user.username}</p>
                                                <p className="text-sm text-gray-500">{user.email}</p>
                                              </div>
                                            </div>
                                            <button
                                              onClick={() => handleFollowClick(user.id, user.privacy_status)}
                                              className={`px-4 py-1 rounded-full ${user.myStatus === "accepted"
                                                ? "bg-gray-400 text-white" // Following
                                                : user.myStatus === "pending"
                                                  ? "bg-yellow-500 text-black" // Requested
                                                  : "bg-[#095228] text-white" // Follow
                                                }`}
                                              disabled={user.myStatus === "pending" || user.myStatus === "accepted"} // Disable if already following or requested
                                            >
                                              {user.myStatus === "accepted"
                                                ? "Following"
                                                : user.myStatus === "pending"
                                                  ? "Requested"
                                                  : "Follow"}
                                            </button>
                                          </li>
                                        ))
                                      ) : (
                                        <p>No users found.</p>
                                      )}
                                    </ul>
                                    {hasMoreUsers && <p className="text-center text-gray-500 mt-4">Loading more...</p>}

                                    <button
                                      onClick={closeModal}
                                      className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              )}
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true

                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full">
                                      <img src={post.user?.profile_picture_url || profileimg} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        onChange={(e) =>
                                          handleCommentChange(post.id, e.target.value)
                                        }
                                        className="flex-1 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex space-x-2">
                                      <button>
                                        <img src={smileyIcon} alt="Smiley" className="w-5 h-5" />
                                      </button>

                                      <label className="cursor-pointer">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}

                                        />
                                      </label>

                                      <button class="px-3">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                      </button>

                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {filePreviews.map((preview, index) => (
                                          <div key={index} className="relative">
                                            {preview.type === "image" ? (
                                              <img
                                                src={preview.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={preview.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() => handleRemoveFile(index)}
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      <button
                                        onClick={() => handleCommentSubmit(post.id, commentInputs[post.id], uploadedMedia)}
                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">

                                        Send
                                      </button>
                                     
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">Comments</h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">{comment.user?.username || "Unknown User"}</p>
                                              <p className="text-sm text-gray-500">{comment.content}</p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        )
                          : (
                            <p>No posts available.</p>
                          )}
                      </div>

                    </div>
                  )
                } */}

                {/* {activeTab === "Groups" && <p>👥 Displaying Groups Feed...</p>} */}
                {
                  activeTab === "Groups" && (
                    <div>
                      {/*  */}
                      {loading && <p>Loading posts...</p>}
                      <div className="w-full">
                        {posts.length > 0 ? (
                          posts.map((post, index) => (
                            <div key={index} className="p-4 border-b border-gray-300">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center" >
                                  <img
                                    src={post.user?.profile_picture_url || profileimg}
                                    alt={post.user?.username || "User"}
                                    className="w-12 h-12 rounded-full mr-4"

                                  />

                                  <div>
                                    <p className="font-bold cursor-pointer text-black-500" onClick={() => handleUsernameClick(post.user?.id)} // Call handleUsernameClick on click
                                    >{post.user?.username || "Unknown User"}</p>
                                    <p className="text-sm text-gray-500">{post.user?.email || "No Email"}</p>
                                  </div>
                                  {/* Display Location */}
                                  {post.location && (
                                    <div className="mt-2 text-sm text-gray-500">
                                      <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                      {post.location}
                                    </div>
                                  )}
                                </div>

                                {/* :white_check_mark: Conditionally render Follow button */}
                                {!post.isOwn && (
                                  <button
                                    onClick={() => handleFollowClick(post.user_id, post.user?.privacy_status)}
                                    className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full mr-4 ${post.myStatus === "accepted"
                                      ? "bg-gray-400 text-white" // :white_check_mark: Following
                                      : post.myStatus === "pending"
                                        ? "bg-yellow-500 text-black" // :white_check_mark: Requested
                                        : "bg-[#095228] text-white" // :white_check_mark: Follow (default)
                                      }`}
                                    disabled={post.myStatus === "pending" || post.myStatus === "accepted"} // :white_check_mark: Disable after clicking
                                  >
                                    {post.myStatus === "accepted"
                                      ? "Following"
                                      : post.myStatus === "pending"
                                        ? "Requested"
                                        : "Follow"}
                                  </button>
                                )}
                              </div>
                              <button
                                placeholder="Share something..."
                                className=""
                                onClick={openPopup} >
                                <p className="mt-2 text-left">{post.content}</p>

                                {/* :white_check_mark: Render Multiple Media Files */}
                                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                  {post?.media_url?.length > 0 && (
                                    post?.media_url?.map((media, mediaIndex) => (
                                      <div key={mediaIndex}>
                                        {media?.media_type === "video" ? (
                                          <video
                                            src={media?.url}
                                            controls
                                            width="100%"
                                            className="rounded-lg shadow-md"
                                          />
                                        ) : (
                                          <img
                                            src={media?.url}
                                            alt={`media-${mediaIndex}`}
                                            width="100%"
                                            className="rounded-lg shadow-md"
                                          />
                                        )}
                                      </div>
                                    ))
                                  )}
                                </div>
                              </button>
                              {/* Social Buttons */}
                              <div className="react-social-cta flex justify-between items-center mt-8">
                                <div className="flex space-x-4">
                                  <button className="like flex items-center space-x-1 text-white px-3 py-1" style={{
                                    background: post.isLiked ? "#F9E9EA" : "#BE1F2E",
                                  }}>
                                    {/* Heart Icon: Calls handleLikeClick */}
                                    <img
                                      src={post.isLiked ? RedlikeIcon : Whiteheart} // Use a filled heart icon if liked
                                      alt="Like"
                                      className="mr-1 cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        handleLikeClick(post.id); // Call handleLikeClick
                                      }}
                                    />

                                    {/* Like Count: Calls fetchLikedUsers */}
                                    <span
                                      className="cursor-pointer" style={{
                                        color: post.isLiked ? "#161F28" : "#FFFFFF",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        fetchLikedUsers(post.id); // Call fetchLikedUsers
                                      }}
                                    >
                                      {post.likeCount}
                                    </span>
                                  </button>

                                  <button
                                    onClick={() => toggleCommentSection(post.id)} // Toggle comment section

                                    className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1">
                                    <img src={commentIcon} alt="Comment" className="mr-1" /> {post.commentCount}
                                  </button>

                                  <button className="eye flex items-center space-x-1 text-black">
                                    <img src={viewIcon} alt="Views" className="mr-1" /> {post.viewsCount} Views
                                  </button>
                                </div>
                                <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                  <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                                </button>
                              </div>
                              {/* Popup for Liked Users */}
                              {isModalOpen && (
                                <div className="fixed inset-0 bg-[#00000005] w-full  z-40 flex justify-center items-center">
                                  <div
                                    onScroll={handleScrollLikedPost} // Attach the scroll handler

                                    className="bg-white p-6 rounded-lg  max-w-md w-full z-50 relative">
                                    <h2 className="text-xl font-bold mb-4">Users who liked this post</h2>
                                    <ul>
                                      {likedUsers.length > 0 ? (
                                        likedUsers.map((user, index) => (
                                          <li key={index} className="mb-2 flex items-center justify-between">
                                            <div className="flex items-center">
                                              <img
                                                src={user.profile_picture_url || profileimg}
                                                alt={user.username}
                                                className="w-8 h-8 rounded-full inline-block mr-2"
                                              />ng dvf
                                              <div>
                                                <p className="font-bold">{user.username}</p>
                                                <p className="text-sm text-gray-500">{user.email}</p>
                                              </div>
                                            </div>
                                            <button
                                              onClick={() => handleFollowClick(user.id, user.privacy_status)}
                                              className={`px-4 py-1 rounded-full ${user.myStatus === "accepted"
                                                ? "bg-gray-400 text-white" // Following
                                                : user.myStatus === "pending"
                                                  ? "bg-yellow-500 text-black" // Requested
                                                  : "bg-[#095228] text-white" // Follow
                                                }`}
                                              disabled={user.myStatus === "pending" || user.myStatus === "accepted"} // Disable if already following or requested
                                            >
                                              {user.myStatus === "accepted"
                                                ? "Following"
                                                : user.myStatus === "pending"
                                                  ? "Requested"
                                                  : "Follow"}
                                            </button>
                                          </li>
                                        ))
                                      ) : (
                                        <p>No users found.</p>
                                      )}
                                    </ul>
                                    {hasMoreUsers && <p className="text-center text-gray-500 mt-4">Loading more...</p>}

                                    <button
                                      onClick={closeModal}
                                      className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* Comment Section */}
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true

                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full">
                                      <img src={post.user?.profile_picture_url || profileimg} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        onChange={(e) =>
                                          handleCommentChange(post.id, e.target.value)
                                        }
                                        className="flex-1 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex items-center">
                                      <button>
                                        <img src={smileyIcon} alt="Smiley" className="w-5 h-5" />
                                      </button>

                                      <label className="cursor-pointer">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}

                                        />
                                      </label>

                                      <button class="">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                      </button>

                                      {/* File Previews */}
                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {filePreviews.map((preview, index) => (
                                          <div key={index} className="relative">
                                            {preview.type === "image" ? (
                                              <img
                                                src={preview.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={preview.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() => handleRemoveFile(index)}
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      <button
                                        onClick={() => handleCommentSubmit(post.id, commentInputs[post.id], uploadedMedia)}
                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">

                                        Send
                                      </button>
                                      {/* <button
                                        onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                      </button> */}
                                      {/* Modal for Comments */}
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">Comments</h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">{comment.user?.username || "Unknown User"}</p>
                                              <p className="text-sm text-gray-500">{comment.content}</p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        )
                          : (
                            <p>No posts available.</p>
                          )}
                      </div>

                    </div>
                  )
                }
                {/* {activeTab === "Followers" && <p>🚀 Displaying Followers Feed...</p>} */}
                {
                  activeTab === "Followers" && (
                    <div>
                      {/*  */}
                      {loading && <p>Loading posts...</p>}
                      <div className="w-full">
                        {posts.length > 0 ? (
                          posts.map((post, index) => (
                            <div key={index} className="p-4 border-b border-gray-300">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center" >
                                  <img
                                    src={post.user?.profile_picture_url || profileimg}
                                    alt={post.user?.username || "User"}
                                    className="w-12 h-12 rounded-full mr-4"

                                  />
                                  <div>
                                    <p className="font-bold cursor-pointer text-black-500" onClick={() => handleUsernameClick(post.user?.id)} // Call handleUsernameClick on click
                                    >{post.user?.username || "Unknown User"}</p>
                                    <p className="text-sm text-gray-500">{post.user?.email || "No Email"}</p>
                                  </div>
                                  {/* Display Location */}
                                  {post.location && (
                                    <div className="mt-2 text-sm text-gray-500">
                                      <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                      {post.location}
                                    </div>
                                  )}
                                </div>

                                {/* :white_check_mark: Conditionally render Follow button */}
                                {!post.isOwn && (
                                  <button
                                    onClick={() => handleFollowClick(post.user_id, post.user?.privacy_status)}
                                    className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full mr-4 ${post.myStatus === "accepted"
                                      ? "bg-gray-400 text-white" // :white_check_mark: Following
                                      : post.myStatus === "pending"
                                        ? "bg-yellow-500 text-black" // :white_check_mark: Requested
                                        : "bg-[#095228] text-white" // :white_check_mark: Follow (default)
                                      }`}
                                    disabled={post.myStatus === "pending" || post.myStatus === "accepted"} // :white_check_mark: Disable after clicking
                                  >
                                    {post.myStatus === "accepted"
                                      ? "Following"
                                      : post.myStatus === "pending"
                                        ? "Requested"
                                        : "Follow"}
                                  </button>
                                )}
                              </div>
                              <button
                                placeholder="Share something..."
                                className=""
                                onClick={() => openPopup(post)} >

                                <p className="mt-2 text-left">{post.content}</p>
                                {/* :white_check_mark: Render Multiple Media Files */}
                                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                  {post?.media_url?.length > 0 && (
                                    post?.media_url?.map((media, mediaIndex) => (
                                      <div key={mediaIndex}>
                                        {media?.media_type === "video" ? (
                                          <video
                                            src={media?.url}
                                            controls
                                            width="100%"
                                            className="rounded-lg shadow-md"
                                          />
                                        ) : (
                                          <img
                                            src={media?.url}
                                            alt={`media-${mediaIndex}`}
                                            width="100%"
                                            className="rounded-lg shadow-md"
                                          />
                                        )}
                                      </div>
                                    ))
                                  )}
                                </div>
                              </button>
                              {/* Social Buttons */}
                              <div className="react-social-cta flex justify-between items-center mt-8">
                                <div className="flex space-x-4">
                                  <button className="like flex items-center space-x-1 border-[#BE1F2E] border-2 text-white px-3 py-1" style={{
                                    background: post.isLiked ? "#F9E9EA" : "#BE1F2E",
                                  }}>
                                    {/* Heart Icon: Calls handleLikeClick */}
                                    <img
                                      src={post.isLiked ? RedlikeIcon : Whiteheart} // Use a filled heart icon if liked
                                      alt="Like"
                                      className="mr-1 cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        handleLikeClick(post.id); // Call handleLikeClick
                                      }}
                                    />

                                    {/* Like Count: Calls fetchLikedUsers */}
                                    <span
                                      className="cursor-pointer" style={{
                                        color: post.isLiked ? "#161F28" : "#FFFFFF",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent triggering parent click events
                                        fetchLikedUsers(post.id); // Call fetchLikedUsers
                                      }}
                                    >
                                      {post.likeCount}
                                    </span>
                                  </button>

                                  <button
                                    onClick={() => toggleCommentSection(post.id)} // Toggle comment section

                                    className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1">
                                    <img src={commentIcon} alt="Comment" className="mr-1" />
                                    <button
                                      placeholder="Share something..."
                                      className=""
                                      onClick={() => openPopup(post)} >{post.commentCount}
                                    </button>
                                  </button>

                                  <button onClick={() => toggleCommentSection(post.id)} className="eye flex items-center space-x-1 text-black">
                                    <img src={viewIcon} alt="Views" className="mr-1" />
                                    <button
                                      placeholder="Share something..."
                                      className=""
                                      onClick={openPopup} > {post.viewsCount} Views
                                    </button>
                                  </button>
                                </div>
                                <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                  <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                                </button>
                              </div>
                              {/* Popup for Liked Users */}
                              {isModalOpen && (
                                <div className="fixed inset-0 bg-[#00000005] w-full  z-40 flex justify-center items-center">
                                  <div
                                    onScroll={handleScrollLikedPost} // Attach the scroll handler

                                    className="bg-white p-6 rounded-lg  max-w-md w-full z-50 relative">
                                    <h2 className="text-xl font-bold mb-4">Users who liked this post</h2>
                                    <ul>
                                      {likedUsers.length > 0 ? (
                                        likedUsers.map((user, index) => (
                                          <li key={index} className="mb-2 flex items-center justify-between">
                                            <div className="flex items-center">
                                              <img
                                                src={user.profile_picture_url || profileimg}
                                                alt={user.username}
                                                className="w-8 h-8 rounded-full inline-block mr-2"
                                              />
                                              <div>
                                                <p className="font-bold">{user.username}</p>
                                                <p className="text-sm text-gray-500">{user.email}</p>
                                              </div>
                                            </div>
                                            <button
                                              onClick={() => handleFollowClick(user.id, user.privacy_status)}
                                              className={`px-4 py-1 rounded-full ${user.myStatus === "accepted"
                                                ? "bg-gray-400 text-white" // Following
                                                : user.myStatus === "pending"
                                                  ? "bg-yellow-500 text-black" // Requested
                                                  : "bg-[#095228] text-white" // Follow
                                                }`}
                                              disabled={user.myStatus === "pending" || user.myStatus === "accepted"} // Disable if already following or requested
                                            >
                                              {user.myStatus === "accepted"
                                                ? "Following"
                                                : user.myStatus === "pending"
                                                  ? "Requested"
                                                  : "Follow"}
                                            </button>
                                          </li>
                                        ))
                                      ) : (
                                        <p>No users found.</p>
                                      )}
                                    </ul>
                                    {hasMoreUsers && <p className="text-center text-gray-500 mt-4">Loading more...</p>}

                                    <button
                                      onClick={closeModal}
                                      className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* Comment Section */}
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true

                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-[400px]">
                                      <img src={post.user?.profile_picture_url || profileimg} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        onChange={(e) =>
                                          handleCommentChange(post.id, e.target.value)
                                        }
                                        className="flex-1 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex items-center">
                                      <button class="pr-2">
                                        <img src={smileyIcon} alt="Smiley" className="w-5 h-5" />
                                      </button>

                                      <label className="cursor-pointer pr-2">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}

                                        />
                                      </label>

                                      <button class="pr-2">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-5 h-5" />
                                      </button>

                                      {/* File Previews */}
                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {uploadedMedia.map((media, index) => (
                                          <div key={index} className="relative">
                                            {media.type === "image" ? (
                                              <img
                                                src={media.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={media.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() => handleRemoveFile(index)}
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      <button
                                        onClick={() => handleCommentSubmit(post.id, commentInputs[post.id], uploadedMedia)}
                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">

                                        Send
                                      </button>
                                      {/* <button
                                        onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                      </button> */}
                                      {/* Modal for Comments */}
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">Comments</h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">{comment.user?.username || "Unknown User"}</p>
                                              <p className="text-sm text-gray-500">{comment.content}</p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        )
                          : (
                            <p>No posts available.</p>
                          )}
                      </div>

                    </div>
                  )
                }
              </div>
            </div>
            {/* <Viewpost /> */}
            <RightResponsivesidebar />
          </div>
          {/* Right Sidebar */}
          <Rightsidebar />

        </main >
      </main >






      <div>
        {/* Create Post */}

        {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
        {isPopupOpen && (
          <div className="popup-share viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
            <div className="border-popup bg-white rounded-lg  relative">
              <div className="flex justify-between">
                <div className="logo-popup flex items-center justify-center space-x-2 ">
                  <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
                </div>
                {/* Close Button */}
                <button className="close-pop-x relative  text-gray-500" onClick={() => setIsPopupOpen(false)}
                >                                <img src={closecircle} alt="Pipaan Logo" className="w-10 h-10" />
                </button>
              </div>
              {/* Modal Content */}
              {/* Swiper Banner with Thumbnails */}
              <div className="swiper-viewpost-slider">
                <div className="relative">
                  <Swiper
                    modules={[Navigation, Pagination, Thumbs]}
                    navigation
                    pagination={{ clickable: true }}
                    thumbs={{ swiper: thumbsSwiper }} // ✅ Link with thumbnails
                    onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)} // ✅ Track active slide
                    className="rounded-lg mt-4 view-post-swiper"
                  >
                    {selectedPost?.media_url?.map((media, index) => (

                      <SwiperSlide key={index}>
                        {media.media_type === "video" ? (
                          <div className="w-full max-h-[fit-content] rounded-lg overflow-hidden">
                            <ReactPlayer
                              url={media.url}
                              playing={playingIndex === index} // ✅ Play only when clicked
                              controls
                              width="auto"
                              height="100%"
                              className="rounded-lg h-full video-player-swiper"
                              light={groupimg} // ✅ Thumbnail before playing

                              playIcon={<img src={play} alt="Play" className="player" />}
                            />
                          </div>
                        ) : (
                          <img
                            src={media.url}
                            alt={`Slide ${index}`}
                            className="w-full max-h-[800px] object-cover rounded-lg transition-transform duration-300"
                          />
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* Zoom Buttons (Apply to Active Image Only) */}
                  <div className="absolute top-0 z-[99] right-4 flex space-x-2 bg-[#ffffffba] rounded-lg items-center">
                    <div className="flex">
                      <button onClick={zoomIn} className=" p-2 rounded-lg ">
                        {/* <img src={zoomInicon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                          <path d="M15.7096 15.5001C15.5836 15.5001 15.4576 15.4511 15.3666 15.3601L14.0646 14.0581C13.8756 13.8691 13.8756 13.5611 14.0646 13.3651C14.2536 13.1761 14.5616 13.1761 14.7576 13.3651L16.0596 14.6671C16.2486 14.8561 16.2486 15.1641 16.0596 15.3601C15.9616 15.4511 15.8356 15.5001 15.7096 15.5001Z" fill="#292D32" />
                          <path d="M8.8502 1.5C5.1822 1.5 2.2002 4.482 2.2002 8.15C2.2002 11.818 5.1822 14.8 8.8502 14.8C12.5182 14.8 15.5002 11.818 15.5002 8.15C15.5002 4.482 12.5182 1.5 8.8502 1.5ZM10.7402 8.815H9.51519V10.04C9.51519 10.327 9.27719 10.565 8.9902 10.565C8.7032 10.565 8.4652 10.327 8.4652 10.04V8.815H7.2402C6.9532 8.815 6.7152 8.577 6.7152 8.29C6.7152 8.003 6.9532 7.765 7.2402 7.765H8.4652V6.54C8.4652 6.253 8.7032 6.015 8.9902 6.015C9.27719 6.015 9.51519 6.253 9.51519 6.54V7.765H10.7402C11.0272 7.765 11.2652 8.003 11.2652 8.29C11.2652 8.577 11.0272 8.815 10.7402 8.815Z" fill="#292D32" />
                        </svg>
                      </button>
                      <button onClick={zoomOut} className=" p-2 rounded-lg">
                        {/* <img src={zoomOuticon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                          <path d="M10.1002 8.81514H6.6002C6.3132 8.81514 6.0752 8.57714 6.0752 8.29014C6.0752 8.00314 6.3132 7.76514 6.6002 7.76514H10.1002C10.3872 7.76514 10.6252 8.00314 10.6252 8.29014C10.6252 8.57714 10.3872 8.81514 10.1002 8.81514Z" fill="#292D32" />
                          <path d="M8.3498 15.3251C4.3948 15.3251 1.1748 12.1051 1.1748 8.1501C1.1748 4.1951 4.3948 0.975098 8.3498 0.975098C12.3048 0.975098 15.5248 4.1951 15.5248 8.1501C15.5248 12.1051 12.3048 15.3251 8.3498 15.3251ZM8.3498 2.0251C4.9688 2.0251 2.2248 4.7761 2.2248 8.1501C2.2248 11.5241 4.9688 14.2751 8.3498 14.2751C11.7308 14.2751 14.4748 11.5241 14.4748 8.1501C14.4748 4.7761 11.7308 2.0251 8.3498 2.0251Z" fill="#292D32" />
                          <path d="M15.6996 16.0252C15.5666 16.0252 15.4336 15.9762 15.3286 15.8712L13.9286 14.4712C13.7256 14.2682 13.7256 13.9322 13.9286 13.7292C14.1316 13.5262 14.4676 13.5262 14.6706 13.7292L16.0706 15.1292C16.2736 15.3322 16.2736 15.6682 16.0706 15.8712C15.9656 15.9762 15.8326 16.0252 15.6996 16.0252Z" fill="#292D32" />
                        </svg>
                      </button>
                    </div>
                    <span className="h-5 border-r border-[#7A7A7A]"></span>
                    <button className=" p-2 rounded-lg ">
                      {/* <img src={exporticon} className="w-[16.8px] h-[16.8px]" /> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <path d="M9.6004 8.32511C9.4674 8.32511 9.3344 8.27611 9.2294 8.17111C9.0264 7.96811 9.0264 7.63211 9.2294 7.42911L14.9694 1.68912C15.1724 1.48612 15.5084 1.48612 15.7114 1.68912C15.9144 1.89212 15.9144 2.22812 15.7114 2.43112L9.9714 8.17111C9.8664 8.27611 9.7334 8.32511 9.6004 8.32511Z" fill="#292D32" />
                        <path d="M15.8996 5.3851C15.6126 5.3851 15.3746 5.1471 15.3746 4.8601V2.0251H12.5396C12.2526 2.0251 12.0146 1.7871 12.0146 1.5001C12.0146 1.2131 12.2526 0.975098 12.5396 0.975098H15.8996C16.1866 0.975098 16.4246 1.2131 16.4246 1.5001V4.8601C16.4246 5.1471 16.1866 5.3851 15.8996 5.3851Z" fill="#292D32" />
                        <path d="M11 16.0251H6.8C2.999 16.0251 1.375 14.4011 1.375 10.6001V6.4001C1.375 2.5991 2.999 0.975098 6.8 0.975098H8.2C8.487 0.975098 8.725 1.2131 8.725 1.5001C8.725 1.7871 8.487 2.0251 8.2 2.0251H6.8C3.573 2.0251 2.425 3.1731 2.425 6.4001V10.6001C2.425 13.8271 3.573 14.9751 6.8 14.9751H11C14.227 14.9751 15.375 13.8271 15.375 10.6001V9.2001C15.375 8.9131 15.613 8.6751 15.9 8.6751C16.187 8.6751 16.425 8.9131 16.425 9.2001V10.6001C16.425 14.4011 14.801 16.0251 11 16.0251Z" fill="#292D32" />
                      </svg>
                    </button>
                  </div>
                </div>
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {!isVideo && (
                  <Swiper
                    onSwiper={setThumbsSwiper} // ✅ Set Swiper instance
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode
                    watchSlidesProgress
                    className="mt-2"
                  >
                    {selectedPost?.media_url?.map((media, index) =>
                      media.media_type === "image" ? (
                        <SwiperSlide key={index} onClick={() => thumbsSwiper.slideTo(index)}>
                          <img
                            src={media.url}
                            alt={`Thumbnail ${index}`}
                            className="w-full h-20 object-cover rounded-lg cursor-pointer"
                          />
                        </SwiperSlide>
                      ) : null
                    )}
                  </Swiper>
                )}
              </div>

              {/* Content Below */}
              <div className="w-full">
                {selectedPostId && selectedPost ? (
                  <div className="p-4 border-b border-gray-300 relative">
                    <div className="react-social-cta flex justify-between items-center my-8">
                      <div className="flex space-x-4">
                        <button className="like flex items-center space-x-1 border-[#BE1F2E] border-[2px] bg-[#F9E9EA] text-[#161F28] px-3 py-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none" className="mr-1">
                            <path d="M9.94944 15.9242C9.66292 16.0253 9.19101 16.0253 8.90449 15.9242C6.46067 15.0899 1 11.6096 1 5.71067C1 3.10674 3.09831 1 5.68539 1C7.2191 1 8.57584 1.74157 9.42697 2.88764C10.2781 1.74157 11.6433 1 13.1685 1C15.7556 1 17.8539 3.10674 17.8539 5.71067C17.8539 11.6096 12.3933 15.0899 9.94944 15.9242Z" stroke="#BE1F2E" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> {selectedPost.likeCount}k
                        </button>
                      </div>
                      <button className="flex items-center space-x-1 text-[#fff] share-post-cta ml-3">
                        <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                      </button>
                    </div>
                    <div className="flex items-center justify-between space-x-3">
                      <div className="flex items-center">
                        <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                          <img
                            src={selectedPost.user?.profile_picture_url || profileimg}
                            alt={selectedPost.user?.username || "User"}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="feed-title pl-4">
                          <p className="font-semibold">{selectedPost.user?.username || "Unknown User"}</p>
                          <p className="flex text-sm text-[#747474]">
                            {new Date(selectedPost.created_at).toLocaleDateString()} |
                            <span className="flex items-center ml-1 cursor-pointer">
                              <img src={greenglobal} alt="" className="mr-1" />
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex">

                        <div className="view-sharepost-drpdown">
                          <button
                            onClick={toggleDropdown}
                            className="share-public flex items-center px-2 py-2"
                          >
                            <img src={morecircle} alt="Globe" className="" />
                          </button>

                          {isOpen && (
                            <div className="absolute bg-white shadow-md rounded-md w-40 p-2">
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 1</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 2</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <p className="my-4 ml-[80px]">{selectedPost.content}</p>
                  </div>
                ) : (
                  <p>No posts available.</p>
                )}
              </div>
              {/* CHAT CONTENT AREA */}
              <div className="dashboard w-full  flex mx-auto">
                <main className="flex w-full">
                  <div className="flex flex-col  w-full">
                    {/* CHAT FOOTER (INPUT AREA) */}
                    <CommentSection comments={comments} setComments={setComments} postId={selectedPostId}
                      handleCommentSubmit={handleCommentSubmit}
                      fetchReplies={fetchReplies}
                      handleCommentLikeClick={handleCommentLikeClick}
                      fetchComments={fetchComments}
                    />                  </div>
                </main>
              </div>
            </div>
          </div>
        )}
      </div>
    </div >
  );
}
const CommentSection = ({ comments, setComments, postId, handleCommentSubmit, fetchReplies, handleCommentLikeClick, fetchComments, post }) => {
  // const [comments, setComments] = useState([]); // Initialize with an empty array
  console.log("Comments State:", comments); // Debugging log


  const [commentText, setCommentText] = useState("");
  const [replyText, setReplyText] = useState({});
  const [showReplyBox, setShowReplyBox] = useState({});
  const [uploadedMedia, setUploadedMedia] = useState([]); // Track uploaded media
  const [expandedReplies, setExpandedReplies] = useState({}); // Track expanded replies


  const handleFetchReplies = (commentId) => {
    if (!expandedReplies[commentId]) {
      fetchReplies(commentId); // Fetch replies only if not already expanded
      setExpandedReplies((prev) => ({ ...prev, [commentId]: true })); // Mark as expanded
    } else {
      setExpandedReplies((prev) => ({ ...prev, [commentId]: false })); // Collapse replies
    }
  };
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);

    const newMedia = files.map((file) => ({
      file: file, // Store the actual file
      type: file.type.startsWith("image/") ? "image" : "video",
      url: URL.createObjectURL(file), // Generate a preview URL
    }));

    setUploadedMedia((prev) => [...prev, ...newMedia]);
    console.log("New Media Added:", newMedia); // Debugging log
  };


  // Function to add a reply
  const handleAddReply = async (commentId) => {
    const token = sessionStorage.getItem("accessToken");
    const user = JSON.parse(sessionStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a reply.");
      return;
    }

    const replyContent = replyText[commentId];
    if (!replyContent?.trim()) return;

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/comment/add-comment",
        {
          media_url: [], // Add media if applicable
          post_id: postId,
          content: replyContent,
          parent_id: commentId, // Use the parent comment ID
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        const newReply = {
          id: response.data.result.id, // Use the returned ID
          name: `${user.first_name} ${user.last_name}`, // Use first_name and last_name from sessionStorage
          avatar: user.profile_picture_url || "/path-to-avatar.jpg", // Use user's profile picture or default avatar
          text: replyContent,
          time: new Date(response.data.result.created_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          likes: 0,
        };

        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === commentId
              ? { ...comment, replies: [...comment.replies, newReply] }
              : comment
          )
        );

        setReplyText((prev) => ({ ...prev, [commentId]: "" })); // Clear the reply input
        setShowReplyBox((prev) => ({ ...prev, [commentId]: false })); // Hide the reply box
        alert("Reply added successfully!");
      } else {
        console.error("Failed to add reply:", response.data.message);
      }
    } catch (error) {
      console.error("Error adding reply:", error);
    }
  };
  const handleSubmitComment = async () => {
    await handleCommentSubmit(postId, commentText, uploadedMedia);
    setCommentText("");  // ✅ clear the text
    setUploadedMedia([]); // ✅ clear the media attachments
  };
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [editingComment, setEditingComment] = useState(null);
  const [editedContent, setEditedContent] = useState("");

  const toggleDropdown = (id) => {
    setOpenDropdownId((prev) => (prev === id ? null : id));
  };

  const startEditingComment = (comment) => {
    setEditingComment(comment);
    setEditedContent(comment.text);
    setOpenDropdownId(null);
  };

  const updateComment = async (comment, userId) => {
    const token = sessionStorage.getItem("accessToken");
    // const user = JSON.parse(sessionStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/comment/edit-comment",
        {
          comment_id: comment.id,
          user_id: userId,
          post_id: comment.post_id,
          content: editedContent,
          media_url: [], // or attach actual media if needed
          is_deleted: false,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setComments((prev) =>
          prev.map((c) =>
            c.id === comment.id ? { ...c, text: editedContent } : c
          )
        );
        setEditingComment(null);
        console.log("Comment updated successfully");
      }
    } catch (err) {
      console.error("Error updating comment:", err);
    }
  };

  const deleteComment = async (comment, userId) => {
    if (!window.confirm("Are you sure you want to delete this comment?")) return;
    const token = sessionStorage.getItem("accessToken");
    // const user = JSON.parse(sessionStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/comment/edit-comment",
        {
          comment_id: comment.id,
          user_id: userId,
          post_id: comment.post_id,
          content: comment.text,
          media_url: [],
          is_deleted: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setComments((prev) => prev.filter((c) => c.id !== comment.id));
        console.log("Comment deleted successfully");
        await fetchComments(comment.post_id);

      }
    } catch (err) {
      console.error("Error deleting comment:", err);
    }
  };

  return (
    <div className="p-4">
      {/* Display Comments and Replies */}
      {comments.map((comment) => (
        <div key={comment.id} className="mb-4 border-b pb-3 relative">

          <div className="flex gap-3">
            <img
              src={profileimg}
              alt="User Avatar"
              className="w-10 h-10 rounded-full"
            />
            <div className="flex-1">
              <div className="bg-[#FEFDEB] p-3 rounded-[20px]">
                <div className="flex justify-between">
                  <p className="font-semibold">{comment.name}</p>
                  <span className="text-[#9397AD] font-[14px]">{comment.time}</span>

                </div>
                {/* <p className="text-gray-700">{comment.text}</p> */}

                {editingComment?.id === comment.id ? (
                  <div className="mt-2">
                    <textarea
                      className="w-full p-2 border rounded"
                      value={editedContent}
                      onChange={(e) => setEditedContent(e.target.value)}
                    />
                    <button
                      className="mt-1 px-3 py-1 bg-blue-600 text-white rounded"
                      onClick={() => updateComment(comment)}
                    >
                      Save
                    </button>
                  </div>
                ) : (
                  <>
                    <p className="text-gray-700">{comment.text}</p>

                    {/* ✅ Add Media Display Block HERE */}
                    {comment.media?.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-2">
                        {comment.media.map((mediaItem, idx) => (
                          mediaItem.media_type === "image" ? (
                            <img
                              key={idx}
                              src={mediaItem.url}
                              alt={`comment-media-${idx}`}
                              className="w-32 h-32 rounded object-cover"
                            />
                          ) : mediaItem.media_type === "video" ? (
                            <video
                              key={idx}
                              controls
                              className="w-64 h-36 rounded"
                            >
                              <source src={mediaItem.url} type="video/mp4" />
                            </video>
                          ) : null
                        ))}
                      </div>
                    )}
                  </>
                )}


                <div className="flex items-center justify-end text-xs text-gray-500 mt-1">
                  <div className="relative">
                    <button onClick={() => toggleDropdown(comment.id)} className="text-gray-500">
                      ⋮
                    </button>
                    {openDropdownId === comment.id && (
                      <div className="absolute right-0 bg-white border rounded shadow-md z-10">
                        <button
                          className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                          onClick={() => startEditingComment(comment)}
                        >
                          Edit
                        </button>
                        <button
                          className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                          onClick={() => deleteComment(comment)}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    className="ml-4 text-[#095228] font-medium "
                    onClick={() => handleFetchReplies(comment.id)}
                  >
                    {expandedReplies[comment.id] ? "Hide Replies" : "View Replies"}
                  </button>
                  <button
                    className="ml-4 mr-2 text-[#095228] font-medium "
                    onClick={() =>
                      setShowReplyBox((prev) => ({
                        ...prev,
                        [comment.id]: !prev[comment.id], // Toggle reply box for this comment
                      }))
                    }
                  >
                    Reply
                  </button>
                  <div className="flex items-center space-x-1">
                    {/* ✅ Pass 'reply' instead of 'post' */}
                    <LikeButton reply={comment}
                      onClick={() => handleCommentLikeClick(comment.id)}

                    />
                    <span className="ml-2 flex items-center"><img src={messagetext} /> &nbsp;{comment.replies.length}</span>
                  </div>
                </div>
              </div>

              {/* Reply Input Box */}

              {showReplyBox[comment.id] && (
                <div className="flex items-center mt-2">
                  <input
                    type="text"
                    value={replyText[comment.id] || ""}
                    onChange={(e) =>
                      setReplyText((prev) => ({
                        ...prev,
                        [comment.id]: e.target.value, // Update reply text for this comment
                      }))
                    }
                    className="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none"
                    placeholder="Write a reply..."
                  />
                  <button
                    onClick={() => handleAddReply(comment.id)}
                    className="ml-2 bg-[#095228] text-[white] px-5 py-2 rounded-[20px]"
                  >
                    Reply
                  </button>
                </div>
              )}
            </div>

          </div>

          {/* Render Replies */}
          {expandedReplies[comment.id] && (

            <div className="ml-14 mt-3">
              {comment.replies.map((reply) => (
                <div key={reply.id} className="flex gap-3 mt-2 relative">
                  <img
                    src={leftconnect}
                    className="absolute left-[-50px] z-99 top-[-51px] h-full"
                  />
                  <img
                    src={profileimg}
                    alt="User Avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <div className="flex-1">
                    <div className="bg-green-100 p-3 rounded-lg">
                      <div className="flex justify-between">
                        <p className="font-semibold">{reply.name}</p>
                        <span className="text-[#9397AD] text-[14px]">{reply.time}</span>
                      </div>
                      <p className="text-gray-700">{reply.text}</p>
                      {/* ✅ Pass 'reply' instead of 'post' */}
                      <div className="flex items-end justify-end space-x-1">
                        <LikeButton
                          reply={reply}
                          onClick={() => handleCommentLikeClick(reply.id)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      {/* Input for adding a new comment */}
      <div className="flex items-center mb-4">




        <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
          {/* Profile Image Upload */}
          <label className="relative cursor-pointer">

            <img
              src={profileimg}
              className="w-[80px] h-[70px] rounded-full object-cover "
            />
          </label>
        </div>


        <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[0px] ">
          <div class="flex space-x-2 ml-3 py-4 microphone-sm">

          </div>

          <input
            placeholder="Add a comment"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            className="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
          />
          
          <div class="flex space-x-2 ml-3 py-4 chat-media-icon">
            <button class="px-3 smiley">
              <img
                src={Smiley}
                className=""
              />
            </button>
            <label className="cursor-pointer">
              <img src={galleryicon} alt="Gallery" />
              <input
                type="file"
                multiple
                accept="image/*,video/*"
                className="hidden"
                onChange={handleFileUpload}
              />
            </label>
          </div>
          {uploadedMedia.length > 0 && (
  <div className="flex flex-wrap gap-2 p-3">
    {uploadedMedia.map((media, idx) => (
      media.media_type === "image" ? (
        <img
                                                src={media.url}
                                                alt={`Preview`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
      ) : (
        <video
          key={idx}
          controls
          src={media.url}
          className="w-32 h-20 rounded"
        />
      )
    ))}
  </div>
)}

          <button className="grp-dashboard-submit-cta text-white px-5 py-3 h-full rounded-[25px] mx-3"
            onClick={() => handleSubmitComment(commentText, uploadedMedia)} // Pass required parameters
          >Send</button>
        </div>
      </div>
    </div>
  );
};
// ✅ Fix: LikeButton is properly structured with useState
const LikeButton = ({ reply, onClick }) => {
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    setLiked(reply?.isLiked || false);
  }, [reply]);

  const handleClick = () => {
    setLiked(!liked);
    onClick(); // Call parent handler
  };

  return (
    <div className="mr-2">
      <span
        className="flex items-center space-x-1 cursor-pointer"
        onClick={handleClick}
      >
        <img
          src={liked ? Redheart : RedlikeIcon}
          alt="Like Icon"
          className={`transition duration-300 ${liked ? "w-6 h-6" : "w-6 h-5"}`}
        />
        <span>{reply?.likes}</span>
      </span>
    </div>
  );
};
